import './Tooltip.scss';

import React from 'react';
import ReactTooltip from 'react-tooltip';

const Tooltip = () => {
	return <ReactTooltip className='tooltip-custom-style' effect='solid' type='dark' multiline />;
};

export default Tooltip;
